import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useFriendList } from '../../utils/hooks/useFriendList';
import UserInput from '../_partials/UserInput';
import UserList from '../_partials/UserList';
import s from './DeviantsListModal.scss';
const DeviantsListCard = ({ selectedUserId, onItemClick, requestClose })=>{
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');
    const { users, streamId, isLoading, isInitialized } = useFriendList(searchTerm);
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'deviantssearch'
        }
    }, /*#__PURE__*/ React.createElement(DSModal, {
        heading: t('deviantList.dialogTitle'),
        className: s['root'],
        onRequestClose: requestClose,
        isOpen: true,
        withScrollableContentWrapper: false
    }, isInitialized && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UserInput, {
        value: searchTerm,
        onChange: setSearchTerm,
        className: s['filter-input']
    }), /*#__PURE__*/ React.createElement(UserList, {
        streamId: streamId,
        users: users,
        className: s['list'],
        isLoading: isLoading,
        selectedUserId: selectedUserId,
        onItemClick: onItemClick
    })), !isInitialized && /*#__PURE__*/ React.createElement(LoadingIndicator, null)));
};
DeviantsListCard.displayName = 'DeviantsListCard';
export default DeviantsListCard;

//# sourceMappingURL=DeviantsListModal.js.map